import React, { useEffect, useState } from 'react';
import { transactionApi } from '../services/api';
import './TransactionPage.css';

function BackOfficeTransactionBlotter() {
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [comment, setComment] = useState('');

  // Fetch transactions for back office
  useEffect(() => {
    const fetchTransactions = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const all = await transactionApi.getAll();
        console.log('Fetched transactions for back office:', all);
        // Show all transactions escalated to back office for verification
        const filtered = all.filter(
          tx =>
            String(tx.current_approval_level).toLowerCase() === 'back_office' &&
            (
              String(tx.approval_status || '').toLowerCase() === 'approved' ||
              String(tx.status || '').toLowerCase() === 'approved' ||
              String(tx.status || '').toLowerCase() === 'pending'
            )
        );
        setTransactions(filtered);
      } catch (err) {
        setError('Failed to load transactions');
      } finally {
        setIsLoading(false);
      }
    };
    fetchTransactions();
  }, []);

  const handleVerify = async (dealNumber, status) => {
    setIsLoading(true);
    setError(null);
    try {
      if (status === 'rejected' && !comment) {
        setError('Comment required for rejection');
        setIsLoading(false);
        return;
      }
      let user = JSON.parse(localStorage.getItem('user') || '{}');
      // Force role to back_office for BOTH approval and rejection to guarantee backend logic triggers
      user = { ...user, role: 'back_office' };

      await transactionApi.update(dealNumber, {
        status,
        comment: status === 'rejected' ? comment : '',
        ...(status === 'approved' ? { current_approval_level: 'back_office_final' } : {})
      }, {
        headers: {
          'x-user-data': JSON.stringify(user)
        }
      });
      setShowDetails(false);
      setComment('');
      // Refresh
      const all = await transactionApi.getAll();
      const filtered = all.filter(
        tx =>
          String(tx.current_approval_level).toLowerCase() === 'back_office' &&
          (
            String(tx.approval_status || '').toLowerCase() === 'approved' ||
            String(tx.status || '').toLowerCase() === 'approved' ||
            String(tx.status || '').toLowerCase() === 'pending'
          )
      );
      setTransactions(filtered);
    } catch (err) {
      setError('Failed to update transaction');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="transaction-page-container sister-blotter">
      <h2>Back Office Transaction Blotter</h2>
      {isLoading && <div className="loader">Loading...</div>}
      {error && <div className="error-message">{error}</div>}
      <table className="transactions-table">
        <thead>
          <tr>
            <th>Deal Number</th>
            <th>Trade Date</th>
            <th>Security</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((tx, index) => (
            <tr key={tx.deal_number || index}>
              <td>{tx.deal_number || 'N/A'}</td>
              <td>{tx.trade_date}</td>
              <td>{tx.security_name}</td>
              <td>{Number(tx.amount).toFixed(4)}</td>
              <td>{tx.status}</td>
              <td>
                <button onClick={() => { setSelectedTransaction(tx); setShowDetails(true); }}>Verify</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showDetails && selectedTransaction && (
        <div className="modal">
          <div className="modal-content">
            <h3>Transaction Details</h3>
            <pre>{JSON.stringify(selectedTransaction, null, 2)}</pre>
            <textarea
              placeholder="Add comment (required for rejection)"
              value={comment}
              onChange={e => setComment(e.target.value)}
              style={{ width: '100%' }}
            />
            <button onClick={() => handleVerify(selectedTransaction.deal_number, 'approved')}>Approve</button>
            <button onClick={() => handleVerify(selectedTransaction.deal_number, 'rejected')}>Reject</button>
            <button onClick={() => { setShowDetails(false); setComment(''); }}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default BackOfficeTransactionBlotter;
